module.exports = __webpack_public_path__ + "img/Lopes_valor@2x.55eaaaad.png";